var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail-form',{ref:"dForm",attrs:{"typeList":_vm.typeList,"orgList":_vm.orgList,"assetsList":_vm.assetsList,"data":_vm.chooseData},on:{"dataUpdate":_vm.dataUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }